import { render, staticRenderFns } from "./default.vue?vue&type=template&id=c0981fee&scoped=true&"
import script from "./default.vue?vue&type=script&lang=js&"
export * from "./default.vue?vue&type=script&lang=js&"
import style0 from "./default.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./default.vue?vue&type=style&index=1&lang=css&"
import style2 from "./default.vue?vue&type=style&index=2&id=c0981fee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0981fee",
  null
  
)

export default component.exports